module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wIR7Mj/tc-custom/9781631957192.jpg?1735702245138",
      "alt": "This image is the cover for the book 49 Days Back to Better"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("49 Days Back to Better\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("It seems much of what society thought was normal about life and the world has changed."), _c('br')]), _c('p', [_vm._v("A tiny unseen virus has shut down businesses, crippled nations, and taken the lives of precious people. Those lives can never be replaced. And then there is the petty stuff like finding a single roll of toilet paper at the supermarket. People are wearing masks and gloves to protect themselves and others from this unseen enemy potentially hiding inside of friends, neighbors, and family members. Normal just isn‚Äôt normal anymore. Normal is just a place in people‚Äôs minds that everyone seems to want to get back to as soon as possible. Some people are even calling it a new normal, but what is that?"), _c('br')]), _c('p', [_vm._v("As the concept of going back to better is considered, Dr. Tim Hill, Tim Enochs, and Adam Enochs fully understand that some losses can never be replaced, and in that realm, there is no going back to better. In 49 Days Back to Better, they focus on areas where there is a choice whether to go back to normal in those areas or find the way back to something better.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tim Hill\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Morgan James Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0